import { Component, OnInit, OnDestroy } from '@angular/core';
import { TccDetailService } from '../services/tcc-detail.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { IUser } from '../interfaces/iuser';
import { AuthService } from '../services/auth.service';
import { Subscription, Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-tcc-admin',
  templateUrl: './tcc-admin.component.html',
  styleUrls: ['./tcc-admin.component.scss']
})
export class TccAdminComponent implements OnInit, OnDestroy{
  
  public login : boolean;
  public user:any;
  public tccdetail: Observable<[]>;
  private subscription : Subscription = new Subscription();
  private _resetPasswordVisible: boolean;
  private _tableIsVisible: boolean = true;
  public searchValue: any = '';
  dtOptions: DataTables.Settings = { };
  dtTrigger: Subject<any> = new Subject();
  
 
  constructor(private tccservice : TccDetailService, private router : Router, private auth:AuthService) { }

  public get resetPasswordVisible(): boolean {
    return this._resetPasswordVisible;
  }
  public get tableIsVisible(): boolean {
    return this._tableIsVisible;
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      processing: true,
      paging:   true,
      ordering: true,
      info:     true

    };
    this.tccdetail = this.tccservice.getTccDetails();
    // Calling the DT trigger to manually render the table
    //this.dtTrigger.next();
    // this.subscription.add(
    //   this.tccservice.getTccDetails().subscribe(data=>{this.tccdetail = data;})
    // ); 
    this.login = this.auth.isLoggedIn;
    if(this.login){
      this.subscription.add(
        this.auth.getCurrentUserTest().subscribe(v=>{this.user = v;},err=>{console.log(err)})
      );
    }
  }

  public showSection(sectionNumber: number) {
    sectionNumber = +sectionNumber;
    if (sectionNumber ===1) {
      this._resetPasswordVisible = false;
      this._tableIsVisible = true;
    }
    else if (sectionNumber ===2) {
      this._tableIsVisible = false;
      this._resetPasswordVisible = true;
      
    }
  }
  getDetail(tccno:string){
      this.router.navigate(['/detail', tccno])
  }

  public logout(){
    this.user = "";
    this.auth.loggedOut();
    //this.router.navigate(['/login']);
  }
showReport(){
  this.router.navigate(['/reports']);
}

removeFromScreen(tccn:string){
  //this.inters.message$.subscribe(pId=>this.selectedPurpose=pId)
  let updateStat : Istatus = {
    tccno: tccn,
    status: 'REMOVED',
    username: this.user.sub,
    period: null,
    purpose: null
   };

  this.subscription.add(
    this.tccservice.updateTccStatus(updateStat).subscribe(data=>{
     let update = data;
     Swal.fire("This record has been removed from your eDesk. In case you still see it, please refresh the page");
    
     // this.router.navigate(['/admin']);
    //code to remove item from this.tccdetail with given tccno
     this.router.onSameUrlNavigation
  })
  );
}

  ngOnDestroy(): void {
    this.subscription.unsubscribe;
    this.dtTrigger.unsubscribe();
  }

  // filterTaxpayer(value:string){
  //   this.searchValue= value;
  //     this.tccdetail= this.tccservice.getTccDetails().pipe(filter((element:any)=>element.TAXPAYER_NAME.includes(this.searchValue)))
  //     //console.log(this.tccdetail)
  
  // }
}
